import { useEffect, useState } from 'react';
import { JoveButton } from '@jove-frontend/mui';
import { QuoteBillingCycleEnum, formatCurrency } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import LinkableText from './linkableText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChatMessagePriceInfoCardView = function ChatMessagePriceInfoCardView(props) {
  var _message$options;

  var message = props.message,
      buttonClick = props.buttonClick,
      linkClick = props.linkClick;

  var _useState = useState(QuoteBillingCycleEnum.ANNUAL),
      billingCycle = _useState[0],
      setBillingCycle = _useState[1];

  var _useState2 = useState([]),
      priceInfoList = _useState2[0],
      setPriceInfoList = _useState2[1];

  var _useState3 = useState(''),
      totalText = _useState3[0],
      setTotalText = _useState3[1];

  var _useState4 = useState(''),
      annualDiscountText = _useState4[0],
      setAnnualDiscountText = _useState4[1];

  var _useState5 = useState(''),
      downPaymentText = _useState5[0],
      setDownPaymentText = _useState5[1];

  var _useState6 = useState(''),
      nextPaymentText = _useState6[0],
      setNextPaymentText = _useState6[1];

  var _useState7 = useState(false),
      showPaymentTypeSwitch = _useState7[0],
      setShowPaymentTypeSwitch = _useState7[1];

  useEffect(function () {
    if (message) {
      var _billing_schedule$, _billing_schedule$$pr;

      var _ref = (message === null || message === void 0 ? void 0 : message.pricingData) || {},
          currency = _ref.currency,
          annual_billing_discount = _ref.annual_billing_discount,
          monthly = _ref.monthly,
          annual = _ref.annual,
          billing_schedule = _ref.billing_schedule,
          down_payment = _ref.down_payment;

      var displayPriceData = billingCycle === QuoteBillingCycleEnum.MONTHLY ? monthly : annual;
      setShowPaymentTypeSwitch(!!monthly);
      var list = [{
        title: 'Insurance period',
        content: '12 months'
      }, {
        title: 'Insurance premium',
        content: formatCurrency({
          amount: (displayPriceData === null || displayPriceData === void 0 ? void 0 : displayPriceData.insurance_premium) || 0,
          currency: currency
        })
      }];

      if (displayPriceData !== null && displayPriceData !== void 0 && displayPriceData.insurance_premium_tax) {
        list.push({
          title: 'Insurance premium tax',
          content: formatCurrency({
            amount: displayPriceData.insurance_premium_tax,
            currency: currency
          })
        });
      }

      if (displayPriceData !== null && displayPriceData !== void 0 && displayPriceData.processing_fee) {
        list.push({
          title: 'Processing fee',
          content: formatCurrency({
            amount: displayPriceData.processing_fee,
            currency: currency
          })
        });
      }

      if (displayPriceData !== null && displayPriceData !== void 0 && displayPriceData.admin_fee) {
        list.push({
          title: 'Admin fee',
          content: formatCurrency({
            amount: displayPriceData.admin_fee || 0,
            currency: currency
          })
        });
      }

      setPriceInfoList(list);

      if (annual_billing_discount) {
        setAnnualDiscountText("".concat(annual_billing_discount * 100, "%"));
      }

      if (!!(billing_schedule !== null && billing_schedule !== void 0 && (_billing_schedule$ = billing_schedule[1]) !== null && _billing_schedule$ !== void 0 && (_billing_schedule$$pr = _billing_schedule$.price) !== null && _billing_schedule$$pr !== void 0 && _billing_schedule$$pr.total)) {
        setNextPaymentText(formatCurrency({
          amount: billing_schedule[1].price.total,
          currency: currency
        }));
      }

      setDownPaymentText(formatCurrency({
        amount: down_payment || 0,
        currency: currency
      }));
      setTotalText(formatCurrency({
        amount: (displayPriceData === null || displayPriceData === void 0 ? void 0 : displayPriceData.total) || 0,
        currency: currency
      }));
    }
  }, [message, billingCycle]);
  /**
   * methods
   */

  var updateBillingCycle = function updateBillingCycle(value) {
    setBillingCycle(value);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex flex-col space-y-4 px-0.5",
    children: [!!(message !== null && message !== void 0 && message.content) && /*#__PURE__*/_jsx(LinkableText, {
      content: message.content,
      linkClick: linkClick
    }), showPaymentTypeSwitch && /*#__PURE__*/_jsxs(Box, {
      className: "flex w-full flex-row rounded-full bg-[#F1F1F1] px-2 py-1",
      children: [/*#__PURE__*/_jsxs(Box, {
        className: clsx('flex cursor-pointer flex-row items-center justify-center space-x-2 rounded-full px-4 py-3', billingCycle !== QuoteBillingCycleEnum.MONTHLY ? 'bg-white' : 'bg-transparent'),
        sx: {
          flex: billingCycle !== QuoteBillingCycleEnum.MONTHLY ? 2 : 1
        },
        onClick: function onClick() {
          return updateBillingCycle === null || updateBillingCycle === void 0 ? void 0 : updateBillingCycle(QuoteBillingCycleEnum.ANNUAL);
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "subtitle2",
          className: "font-bold text-[#202020]",
          children: "Annual"
        }), billingCycle !== QuoteBillingCycleEnum.MONTHLY && !!annualDiscountText && /*#__PURE__*/_jsxs(Box, {
          className: "flex flex-row rounded-full bg-[#1CB258] px-3 py-1 text-[10px] font-bold text-white",
          children: ["Save ", annualDiscountText]
        })]
      }), /*#__PURE__*/_jsx(Box, {
        className: clsx('flex flex-1 cursor-pointer flex-row items-center justify-center space-x-2 rounded-full px-4 py-3', billingCycle === QuoteBillingCycleEnum.MONTHLY ? 'bg-white' : 'bg-transparent'),
        onClick: function onClick() {
          return updateBillingCycle === null || updateBillingCycle === void 0 ? void 0 : updateBillingCycle(QuoteBillingCycleEnum.MONTHLY);
        },
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle2",
          className: "font-bold text-[#202020]",
          children: "Monthly"
        })
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "space-y-1 px-0.5",
      children: [/*#__PURE__*/_jsxs(Typography, {
        className: "text-[20px] font-black text-[#202020]",
        children: [downPaymentText, /*#__PURE__*/_jsxs("span", {
          className: "text-sm font-bold",
          children: [" / ", billingCycle === QuoteBillingCycleEnum.MONTHLY ? 'month' : 'year']
        })]
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm font-medium text-[#202020]",
        children: billingCycle === QuoteBillingCycleEnum.MONTHLY ? "Pay your down payment today. ".concat(!!nextPaymentText ? ' Then monthly payments of ' + nextPaymentText : '', ".") : 'Pay once today'
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "overflow-hidden rounded-2xl bg-white",
      children: [billingCycle !== QuoteBillingCycleEnum.MONTHLY && !!annualDiscountText && /*#__PURE__*/_jsx(Box, {
        className: "flex items-center justify-center bg-[#1CB258] px-4 py-2",
        children: /*#__PURE__*/_jsxs(Typography, {
          className: "text-[14px] font-semibold leading-5 text-white",
          children: ["Save ", annualDiscountText, " for a limited time only!"]
        })
      }), /*#__PURE__*/_jsx(Box, {
        className: "space-y-2 px-4 py-3",
        children: priceInfoList.map(function (item, index) {
          return /*#__PURE__*/_jsxs(Box, {
            className: "flex items-center justify-between font-medium text-[#202020]",
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "subtitle2",
              children: item.title
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "subtitle2",
              children: item.content
            })]
          }, index);
        })
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex items-center justify-between bg-[#0E35D1] px-4 py-3 font-bold text-white",
        children: [/*#__PURE__*/_jsx(Typography, {
          className: "text-sm",
          children: "Annual total"
        }), /*#__PURE__*/_jsx(Typography, {
          className: "text-base",
          children: totalText
        })]
      })]
    }), (message === null || message === void 0 ? void 0 : (_message$options = message.options) === null || _message$options === void 0 ? void 0 : _message$options.length) > 0 && /*#__PURE__*/_jsx(Box, {
      className: "flex flex-col space-y-2",
      children: message.options.map(function (item, index) {
        return /*#__PURE__*/_jsx(JoveButton, {
          variant: "outlined",
          className: "min-w-[120px]",
          onClick: function onClick() {
            return buttonClick === null || buttonClick === void 0 ? void 0 : buttonClick(item.label);
          },
          children: item.label
        }, index);
      })
    })]
  });
};

export default ChatMessagePriceInfoCardView;